import type { MigawkaZapisu } from "../../lib/autozapis.js";
import { napisStatusuZapisu } from "../../lib/recenzja.js";
import { IconOstrzezenie, IconPtaszek } from "../icons/index.js";
import { Button } from "../ui/Button.js";
import { Spinner } from "../ui/Spinner.js";

/**
 * Stan autozapisu przy pasku postepu: "Zapisuję...", "Zapisano 14:21", "Nie udało się zapisać." z przyciskiem ponowienia.
 *
 * Stan niesie TEKST i ikona, nie sam kolor (A-7, ST-3). Obszar aria-live obejmuje tylko napis: przycisk ponowienia stoi
 * obok, zeby czytnik nie oglaszal go przy kazdej zmianie napisu.
 */
export function StatusZapisu({
  migawka,
  onPonow,
  ogloszenia = true,
}: {
  migawka: Pick<MigawkaZapisu, "stan" | "zapisanoO">;
  onPonow: () => void;
  /**
   * Czy napis jest obszarem aria-live. Pasek postepu ma jeden taki obszar na cala strone; ten sam stan powtorzony przy
   * kazdym otwartym formularzu uwagi nie moze byc oglaszany drugi raz (czytnik powtarzalby kazdy zapis).
   */
  ogloszenia?: boolean;
}): React.JSX.Element {
  const { stan } = migawka;
  return (
    <span className="rec-status-zapisu" data-stan={stan}>
      <span
        className="rec-status-zapisu__napis"
        {...(ogloszenia ? { role: "status", "aria-live": "polite" as const } : {})}
      >
        {stan === "saving" && <Spinner rozmiar="s" />}
        {stan === "saved" && <IconPtaszek size={14} />}
        {stan === "error" && <IconOstrzezenie size={14} />}
        {napisStatusuZapisu(migawka)}
      </span>
      {stan === "error" && (
        <Button wariant="secondary" onClick={onPonow}>
          Spróbuj ponownie
        </Button>
      )}
    </span>
  );
}
